import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// ✅ AFTER imports — no ESLint error
const __originalConsoleError = console.error;

console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    args[0].includes(
      "ResizeObserver loop completed with undelivered notifications"
    )
  ) {
    return;
  }
  __originalConsoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Optional performance logging
reportWebVitals();
